export default "__VITE_ASSET__CTIi5_OX__"